import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import ShieldImg from "../../Assets/Icons/shield.png";
import LoaderBox from "./LoaderBox";

const HomeLive = () => {
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeRoster, setActiveRoster] = useState(null);
  const [hideDataMode, setHideDataMode] = useState(false);
  const [countdownData, setCountdownData] = useState({
    enabled: false,
    target: null,
  });
  const [tournamentWinner, setTournamentWinner] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  useEffect(() => {
    const fetchLiveMatch = async () => {
      setLoading(true);

      // 1. PROVJERA JE LI TURNIR ZAVRŠIO (Tražimo utakmicu Tomić AG - Supersport s rezultatom 2:1 ili općenito finale koje je završeno)
      const { data: completedMatches } = await supabase
        .from("matches")
        .select(`*, team_a:team_a_id (*), team_b:team_b_id (*)`)
        .eq("is_completed", true);

      if (completedMatches) {
        // Tražimo specifičnu finalnu utakmicu (Tomić AG - Supersport koja je završila 2:1)
        const finalMatch = completedMatches.find((m) => {
          const teamA = (m.team_a?.name || "").toLowerCase();
          const teamB = (m.team_b?.name || "").toLowerCase();
          return (
            ((teamA.includes("tomić") && teamB.includes("supersport")) ||
              (teamA.includes("supersport") && teamB.includes("tomić"))) &&
            ((m.scorea === 2 && m.scoreb === 1) ||
              (m.scorea === 1 && m.scoreb === 2))
          );
        });

        // Ako je finale završeno, izračunaj pobjednika
        if (finalMatch) {
          if (finalMatch.scorea > finalMatch.scoreb) {
            setTournamentWinner(finalMatch.team_a?.name);
          } else {
            setTournamentWinner(finalMatch.team_b?.name);
          }
        }
      }

      // 2. DOHVAĆANJE UTROBICE UŽIVO (Tvoj postojeći kod)
      const { data } = await supabase
        .from("matches")
        .select(`*, team_a:team_a_id (*), team_b:team_b_id (*)`)
        .eq("is_live", true)
        .maybeSingle();

      if (data) {
        const preparedData = {
          ...data,
          rostera:
            data.rostera?.length > 0
              ? data.rostera
              : data.team_a?.players || [],
          rosterb:
            data.rosterb?.length > 0
              ? data.rosterb
              : data.team_b?.players || [],
        };
        setMatch(preparedData);
      } else {
        setMatch(null);
      }

      // 3. POSTAVKE ODBROJAVANJA (Tvoj postojeći kod)
      const { data: settings } = await supabase
        .from("site_settings")
        .select("countdown_enabled, countdown_target, hide_data_mode")
        .eq("id", 1)
        .maybeSingle();

      if (settings) {
        if (
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1"
        ) {
          setHideDataMode(false);
        } else {
          // Ako je u site_settings u bazi hide_data_mode true, postavi state na true
          setHideDataMode(settings.hide_data_mode || false);
        }
        setCountdownData({
          enabled: settings.countdown_enabled,
          target: settings.countdown_target,
        });
      }
      setLoading(false);
    };

    fetchLiveMatch();

    const channel = supabase
      .channel("realtime-home-live")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "matches" },
        (payload) => {
          if (payload.new && payload.new.is_live) {
            setMatch((prev) => {
              if (!prev || prev.id !== payload.new.id) {
                fetchLiveMatch();
                return prev;
              }
              return {
                ...prev,
                ...payload.new,
                rostera:
                  payload.new.rostera?.length > 0
                    ? payload.new.rostera
                    : prev.rostera,
                rosterb:
                  payload.new.rosterb?.length > 0
                    ? payload.new.rosterb
                    : prev.rosterb,
                team_a: prev.team_a,
                team_b: prev.team_b,
              };
            });
          } else {
            setMatch(null);
          }
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  // --- TIMER LOGIKA ZA ODBROJAVANJE S HRVATSKOM GRAMATIKOM ---
  useEffect(() => {
    if (!countdownData.enabled || !countdownData.target) return;

    // Pomoćne funkcije za gramatičke nastavke
    const getDaysLabel = (d) => {
      if (d % 10 === 1 && d % 100 !== 11) return "DAN";
      if ([2, 3, 4].includes(d % 10) && ![12, 13, 14].includes(d % 100))
        return "DANA";
      return "DANA"; // Za 0, i sve od 5 nadalje (5 dana, 10 dana, 20 dana)
    };

    const getHoursLabel = (h) => {
      if (h % 10 === 1 && h % 100 !== 11) return "SAT";
      if ([2, 3, 4].includes(h % 10) && ![12, 13, 14].includes(h % 100))
        return "SATA";
      return "SATI";
    };

    const getMinutesLabel = (m) => {
      if (m % 10 === 1 && m % 100 !== 11) return "MINUTA";
      if ([2, 3, 4].includes(m % 10) && ![12, 13, 14].includes(m % 100))
        return "MINUTE";
      return "MINUTA";
    };

    const getSecondsLabel = (s) => {
      if (s % 10 === 1 && s % 100 !== 11) return "SEKUNDA";
      if ([2, 3, 4].includes(s % 10) && ![12, 13, 14].includes(s % 100))
        return "SEKUNDE";
      return "SEKUNDI";
    };

    const calculateTime = () => {
      const targetTime = new Date(countdownData.target).getTime();
      const currentTime = new Date().getTime();

      // Oduzimamo 1 sat (3.600.000 ms) od početka turnira prema dogovoru
      const oneHourInMs = 60 * 60 * 1000;
      const difference = targetTime - oneHourInMs - currentTime;

      if (difference <= 0) {
        setTimeLeft(null);
        return;
      }

      const d = Math.floor(difference / (1000 * 60 * 60 * 24));
      const h = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const m = Math.floor((difference / 1000 / 60) % 60);
      const s = Math.floor((difference / 1000) % 60);

      // Spremamo brojeve i dinamične gramatičke oznake
      setTimeLeft({
        days: String(d).padStart(2, "0"),
        daysLabel: getDaysLabel(d),
        hours: String(h).padStart(2, "0"),
        hoursLabel: getHoursLabel(h),
        minutes: String(m).padStart(2, "0"),
        minutesLabel: getMinutesLabel(m),
        seconds: String(s).padStart(2, "0"),
        secondsLabel: getSecondsLabel(s),
      });
    };

    calculateTime();
    const interval = setInterval(calculateTime, 1000);
    return () => clearInterval(interval);
  }, [countdownData]);

  if (loading) return <LoaderBox text="Provjeravam utakmice uživo..." />;
  // --- ZASLON NAKON ZAVRŠETKA TURNIRA ---
  if (tournamentWinner) {
    return (
      <div className="home-countdown-screen tournament-finished-screen">
        <div className="countdown-glass-card finished-card">
          <div className="countdown-header-zone">
            <div className="countdown-live-pulse">🏆 TURNIR JE ZAVRŠEN</div>
            <h2 className="countdown-main-title" style={{ marginTop: "15px" }}>
              Hvala vam!
            </h2>
            <p className="countdown-sub-title">
              Prvi malonogometni turnir <strong>Podsused</strong> je službeno
              priveden kraju. Hvala svim ekipama, navijačima i sponzorima koji
              su bili dio ove priče!
            </p>
          </div>

          <div className="winner-announcement-box">
            <span
              style={{
                color: "#8fa0ba",
                textTransform: "uppercase",
                fontSize: "0.85rem",
                letterSpacing: "1px",
              }}
            >
              Osvajač turnira
            </span>
            <h1
              style={{
                color: "#fff",
                fontSize: "2.2rem",
                margin: "5px 0 0 0",
                fontFamily: "Kanit",
                fontWeight: "700",
                textShadow: "0 0 20px rgba(0, 180, 255, 0.15)",
              }}
            >
              🥇 {tournamentWinner}
            </h1>
          </div>
        </div>
      </div>
    );
  }
  if (hideDataMode) {
    // Ako je sakrivanje upaljeno, ali je ODBROJAVANJE aktivno i još traje, prikaži countdown zaslon
    if (countdownData.enabled && timeLeft) {
      return (
        <div className="home-countdown-screen">
          <div className="countdown-glass-card">
            <div className="countdown-header-zone">
              <div className="countdown-live-pulse">
                <span className="pulse-dot"></span>
                MNT PODSUSED
              </div>
              <h2 className="countdown-main-title">Turnir uskoro počinje</h2>
              <p className="countdown-sub-title">
                Ostalo je još vrlo malo do prvog malonogometnog turnira
                Podsused. Spremite se!
              </p>
            </div>

            <div className="countdown-ticker-board">
              <div className="ticker-block">
                <div className="ticker-number">{timeLeft.days}</div>
                <div className="ticker-label">{timeLeft.daysLabel}</div>
              </div>

              <div className="ticker-divider">:</div>

              <div className="ticker-block">
                <div className="ticker-number">{timeLeft.hours}</div>
                <div className="ticker-label">{timeLeft.hoursLabel}</div>
              </div>

              <div className="ticker-divider">:</div>

              <div className="ticker-block">
                <div className="ticker-number">{timeLeft.minutes}</div>
                <div className="ticker-label">{timeLeft.minutesLabel}</div>
              </div>

              <div className="ticker-divider">:</div>

              <div className="ticker-block highlight-seconds">
                <div className="ticker-number">{timeLeft.seconds}</div>
                <div className="ticker-label">{timeLeft.secondsLabel}</div>
              </div>
            </div>

            <div className="countdown-footer-note">
              <i className="fi fi-rr-info"></i>
              Rezultati uživo, tablice i strijelci bit će dostupni čim turnir
              krene.
            </div>
          </div>
        </div>
      );
    }

    // Ako countdown NIJE upaljen ili je završio, a sakrivanje je i dalje aktivno, prikaži prazno stanje
    return (
      <div className="home-empty-state">
        <div className="empty-icon"></div>
        <h3>Trenutno nema utakmica uživo</h3>
        <p>Sve utakmice koje su u tijeku pojavit će se ovdje automatski.</p>
        <p>Provjerite raspored za nadolazeće utakmice.</p>
      </div>
    );
  }
  if (!match) {
    if (countdownData.enabled && timeLeft) {
      return (
        <div className="home-countdown-screen">
          <div className="countdown-glass-card">
            <div className="countdown-header-zone">
              <div className="countdown-live-pulse">
                <span className="pulse-dot"></span>
                MNT PODSUSED
              </div>
              <h2 className="countdown-main-title">Turnir uskoro počinje</h2>
              <p className="countdown-sub-title">
                Ostalo je još vrlo malo do prvog malonogometnog turnira
                Podsused. Spremite se!
              </p>
            </div>

            <div className="countdown-ticker-board">
              <div className="ticker-block">
                <div className="ticker-number">{timeLeft.days}</div>
                <div className="ticker-label">{timeLeft.daysLabel}</div>
              </div>

              <div className="ticker-divider">:</div>

              <div className="ticker-block">
                <div className="ticker-number">{timeLeft.hours}</div>
                <div className="ticker-label">{timeLeft.hoursLabel}</div>
              </div>

              <div className="ticker-divider">:</div>

              <div className="ticker-block">
                <div className="ticker-number">{timeLeft.minutes}</div>
                <div className="ticker-label">{timeLeft.minutesLabel}</div>
              </div>

              <div className="ticker-divider">:</div>

              <div className="ticker-block highlight-seconds">
                <div className="ticker-number">{timeLeft.seconds}</div>
                <div className="ticker-label">{timeLeft.secondsLabel}</div>
              </div>
            </div>

            <div className="countdown-footer-note">
              <i className="fi fi-rr-info"></i>
              Rezultati uživo, tablice i strijelci bit će dostupni čim turnir
              krene.
            </div>
          </div>
        </div>
      );
    }

    // Tvoj klasični prazni state ako countdown NIJE upaljen
    return (
      <div className="home-empty-state">
        <div className="empty-icon"></div>
        <h3>Trenutno nema utakmica uživo</h3>
        <p>Sve utakmice koje su u tijeku pojavit će se ovdje automatski.</p>
        <p>Provjerite raspored za nadolazeće utakmice.</p>
      </div>
    );
  }

  return (
    <div className="live-container">
      <div className="live-card">
        <div className="live-badge">
          <span className="dot"></span> UŽIVO
        </div>

        <div className="scoreboard">
          <div className="team">
            <img
              className="club-shield"
              src={match.team_a?.logo_url || ShieldImg}
              alt={match.team_a?.name || "Logo"}
              loading="lazy"
            />
            <span className="team-name">{match.team_a?.name}</span>
          </div>
          <div className="score">
            {match.scorea} : {match.scoreb}
          </div>
          <div className="team">
            <img
              className="club-shield"
              src={match.team_b?.logo_url || ShieldImg}
              alt={match.team_b?.name || "Logo"}
              loading="lazy"
            />
            <span className="team-name">{match.team_b?.name}</span>
          </div>
        </div>

        <div className="match-period">{match.half || "1. poluvrijeme"}</div>

        {/* --- TIMELINE S NOVIM IKONAMA --- */}
        <div className="timeline">
          {match.events && match.events.length > 0 ? (
            match.events
              ?.slice() // Kopiramo niz da ne mutiramo state
              .sort((a, b) => parseInt(a.time) - parseInt(b.time)) // Sortiranje po minutama (uzlazno)
              .map((e, index) => (
                <div
                  key={index}
                  className={`event-row ${e.team === "A" ? "left" : "right"}`}
                >
                  <div className="event-content">
                    <span className="time">{e.time}'</span>
                    <EventIcon type={e.type} />
                    <span className="player">{e.player}</span>
                  </div>
                  <div className="center-line"></div>
                </div>
              ))
          ) : (
            <p className="no-events-text"></p>
          )}
        </div>
        <h5>Popis igrača:</h5>
        <div className="players-list-actions">
          <button
            className={activeRoster === "A" ? "active" : ""}
            onClick={() => setActiveRoster(activeRoster === "A" ? null : "A")}
          >
            {match.team_a?.name || "Tim A"}
          </button>
          <button
            className={activeRoster === "B" ? "active" : ""}
            onClick={() => setActiveRoster(activeRoster === "B" ? null : "B")}
          >
            {match.team_b?.name || "Tim B"}
          </button>
        </div>

        {activeRoster && (
          <div className="players-list shadow-effect">
            <h4>
              Sastav:{" "}
              {activeRoster === "A" ? match.team_a?.name : match.team_b?.name}
            </h4>
            {(activeRoster === "A" ? match.rostera : match.rosterb)
              ?.slice()
              .sort((a, b) => parseInt(a.no) - parseInt(b.no))
              .map((p, i) => (
                <div key={i} className="player-row">
                  <span className="number">{p.no}</span>
                  <span className="name">{p.name}</span>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

// --- TVOJA EVENT ICON KOMPONENTA ---
const EventIcon = ({ type }) => {
  switch (type) {
    case "goal":
      return (
        <div className="goal-icon" title="Gol">
          <i className="fi fi-br-football"></i>
        </div>
      );
    case "penalty":
      return (
        <div className="penalty-icon" title="Penal">
          <i className="fi fi-br-football"></i>
        </div>
      );
    case "penalty-miss":
      return (
        <div className="penalty-icon miss" title="Promašaj">
          <i className="fi fi-rs-cross-small"></i>
        </div>
      );
    case "yellow":
      return (
        <div className="two-min-out-icon" title="2 min">
          <p>2</p>
          <span>min</span>
        </div>
      );
    case "og":
      return (
        <div className="autogoal" title="Autogol">
          AG
        </div>
      );
    default:
      return <div className="c-icon c-default">?</div>;
  }
};

export default HomeLive;
